var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCustomFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0025 20.0728C24.5475 19.9104 24.0397 20.0246 23.6982 20.3661C23.3566 20.7077 23.2424 21.2155 23.4049 21.6704L27.9342 34.3527C28.0807 34.7629 28.4107 35.0809 28.8259 35.2122C29.3216 35.3689 29.8632 35.2366 30.2307 34.8691L33.332 31.7678L36.7765 35.2123C37.1019 35.5377 37.6295 35.5377 37.955 35.2123L38.5442 34.623C38.8697 34.2976 38.8697 33.77 38.5442 33.4445L35.0998 30.0001L38.2011 26.8988C38.5686 26.5312 38.7009 25.9896 38.5442 25.494C38.4129 25.0787 38.0949 24.7487 37.6846 24.6022L25.0025 20.0728ZM35.1962 26.3681L26.6468 23.3147L29.7001 31.8642L35.1962 26.3681Z",
    fill: "#D6DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 10.4165C4.13406 10.4165 2.08203 12.4685 2.08203 14.9998V24.9998C2.08203 27.5311 4.13406 29.5832 6.66537 29.5832H22.4987V27.0832H6.66537C5.51477 27.0832 4.58203 26.1504 4.58203 24.9998V14.9998C4.58203 13.8492 5.51477 12.9165 6.66536 12.9165H33.332C34.4826 12.9165 35.4154 13.8492 35.4154 14.9998V21.6665H37.9154V14.9998C37.9154 12.4685 35.8633 10.4165 33.332 10.4165H6.66536Z",
    fill: "#D6DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCustomFields);
export default __webpack_public_path__ + "static/media/emptyCustomFields.3b6cb7b52244302f9caf19236c6b10a2.svg";
export { ForwardRef as ReactComponent };